import InsightsSection from './InsightsSection';

export default InsightsSection;
